import { createSelector } from 'reselect';
import { RootState } from '../../reducer';

export const authUserSelector = (state: RootState) => state.auth.authUser;

export const selectProfile = createSelector(
  authUserSelector,
  (authUser) => authUser?.attributes.profile
);
